import { AddressType } from 'common/types/address-type'

// Billing address for checkout/calculate so Chargebee can work out tax. Uses
// the billing address saved by the checkout form so far, minus blank fields
// (the API rejects blanks), and falls back to the tenant's country before the
// customer has entered one
export const getCalculateBillingAddress = (
  savedCheckout: string | null | undefined,
  tenantCountry: string,
): Partial<AddressType> => {
  const billing: Partial<AddressType> = savedCheckout
    ? JSON.parse(savedCheckout).billing_address || {}
    : {}
  return {
    country: tenantCountry,
    ...Object.fromEntries(Object.entries(billing).filter(([, v]) => !!v)),
  }
}
